import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addEstudioAmbiental, getFrecuenciasEstudio, getMetodologiasEmpleadas, getTiposEstudio } from "../../../../../../../../redux/actions/resolucion";
import EstudioAmbientalesForm from "./EstudiosAmbientalesForm";


const initialValues = {
    idTipoEstudio: "",
    numeroFrecuencia: "",
    frecuenciaEstudio: "",
    idMetodologiaEmpleada: "",
}

const EstudiosAmbientalesFormContainer = ({ formValues, open, handleClose }) => {
    const dispatch = useDispatch();

    const tiposEstudio = useSelector((state) => state.resolucion.tiposEstudio);
    const frecuenciasEstudio = useSelector((state) => state.resolucion.frecuenciasEstudio);
    const metodologiasEmpleadas = useSelector((state) => state.resolucion.metodologiasEmpleadas);

    const [values, setValues] = useState();
    const [valuesMetodologia, setValuesMetodologia] = useState();
    const [openFormMetodologia, setOpenFormMetodologia] = useState(false);
    const [loadingMetodologiasEmpleadas, setLoadingMetodologiasEmpleadas] = useState(true);
    const [loadingTiposEstudio, setLoadingTiposEstudio] = useState(true);
    const [loadingFrecuenciasEstudio, setLoadingFrecuenciasEstudio] = useState(true);
    const id = values?.index ?? null;


    useEffect(() => {
        if (open) {
            if (tiposEstudio.data.length === 0) {
                dispatch(getTiposEstudio()).finally(() => {
                    setLoadingTiposEstudio(false)
                });
            }
            else setLoadingTiposEstudio(false);

            if (frecuenciasEstudio.data.length === 0) {
                dispatch(getFrecuenciasEstudio()).finally(() => {
                    setLoadingFrecuenciasEstudio(false);
                });
            }
            else setLoadingFrecuenciasEstudio(false);


            if (formValues?.idTipoEstudio) {
                dispatch(getMetodologiasEmpleadas(formValues.idTipoEstudio)).finally(() => {
                    setLoadingMetodologiasEmpleadas(false)
                });
            } else {
                setLoadingMetodologiasEmpleadas(false);

            }
            if (formValues) setValues(formValues);
            else {
                setValues(initialValues);
            }
        } else {
            setLoadingMetodologiasEmpleadas(true);
            setLoadingTiposEstudio(true);
            setLoadingFrecuenciasEstudio(true);
        }

    }, [formValues, open])

    const handleSubmit = (values) => {
        values.nombreTiposEstudio = tiposEstudio.data.find((v) => (v.id === values.idTipoEstudio))?.nombre;

        values.nombreMetodologiaEmpleada = metodologiasEmpleadas.data.find((v) => (v.id === values.idMetodologiaEmpleada))?.nombre;

        dispatch(addEstudioAmbiental(values, id))
        handleClose();
    }

    const handleOpenMetodologiaEmpleada = (values) => {
        setValuesMetodologia({
            ...values,
            nombreTiposEstudio: tiposEstudio.data.find((v) => (v.id === values.idTipoEstudio))?.nombre,
        });
        setOpenFormMetodologia(true)
    }

    return (
        <>
            <EstudioAmbientalesForm
                open={open}
                handleClose={handleClose}
                handleSubmit={handleSubmit}
                values={values}
                id={id}
                loading={loadingTiposEstudio || loadingFrecuenciasEstudio || loadingMetodologiasEmpleadas}
                handleOpenMetodologiaEmpleada={handleOpenMetodologiaEmpleada}
                valuesMetodologia={valuesMetodologia}
                openFormMetodologia={openFormMetodologia}
                handleCloseFormMetodologia={() => { setOpenFormMetodologia(false) }}
            />

        </>
    )

}


export default EstudiosAmbientalesFormContainer;